import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { connect } from 'react-redux'
import * as $ from 'jquery'
import { ModalFormWrapper } from '../../../itrust_common/components/others'
import ClaimForm from './edit/ClaimForm'
import ClaimFormHeader from './edit/ClaimFormHeader'
import RpaClaimForm from '../../../containers/authorised/addOns/rpa/vision_insurance/claimForm/submitClaim/RpaClaimForm'
import { claimFormLoadById, claimFormReset } from '../../../redux/actions/order/claimFormActions'
import { orderLoad } from '../../../redux/actions/order/orderActions'
import { visionInsuranceClaimFormLoad, visionInsuranceClaimFormEdit, visionInsuranceClaimFormReset } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import { getInsuranceLabel } from './claimFormDropdownUtils'
import '../../../assets/sass/spec/components/pages/postCheckModal.scss'

function ClaimFormModal(props) {
  const {
    order,
    selectedOrderInsurance,
    onClose,
    onSubmit,
    onSecureFax,
    onTrizettoSend,
    dispatch,
    trizettoSending,
    ediClearingHouseConfig,
    userRole,
  } = props

  const [activeOrderInsurance, setActiveOrderInsurance] = useState(selectedOrderInsurance)
  const formName = `claimForm-${order.id}`
  const modalId = `${formName}-modal`
  const ordersInsurances = order.orders_insurances_attributes || []

  const isForm1500 = activeOrderInsurance?.vision_insurance_service?.form_1500
  const claimFormInsurances = ordersInsurances.filter(
    (item) => item.claim_form_id || item.visionary_insurance_claim_form_id || item.vision_insurance_service?.form_1500,
  )
  const showClaimForm = Boolean(selectedOrderInsurance)

  useEffect(() => {
    if (!selectedOrderInsurance) {
      setActiveOrderInsurance(null)
      return
    }

    const latestInsurance = order.orders_insurances_attributes?.find(
      (item) => item.id === selectedOrderInsurance.id,
    ) || selectedOrderInsurance

    setActiveOrderInsurance(latestInsurance)
  }, [selectedOrderInsurance, order.orders_insurances_attributes])

  useEffect(() => {
    if (!activeOrderInsurance?.id) {
      return
    }

    dispatch(visionInsuranceClaimFormEdit({ orders_insurance_id: activeOrderInsurance.id }))
    if (activeOrderInsurance.claim_form_id) {
      dispatch(claimFormLoadById(order.id, activeOrderInsurance.claim_form_id, { include: '*' }))
    } else if (isForm1500) {
      dispatch(visionInsuranceClaimFormLoad(order.id, {
        include: '*',
        orders_insurance_id: activeOrderInsurance.id,
      }))
    } else {
      dispatch(visionInsuranceClaimFormLoad(order.id, {
        include: '*',
        orders_insurance_id: activeOrderInsurance.id,
      }))
    }
  }, [
    activeOrderInsurance?.id,
    activeOrderInsurance?.claim_form_id,
    isForm1500,
    dispatch,
    order.id,
  ])

  useEffect(() => {
    if (selectedOrderInsurance) {
      $(`#${modalId}`).modal('show')
    } else {
      $(`#${modalId}`).modal('hide')
    }
  }, [selectedOrderInsurance, modalId])

  const handleClose = () => {
    // Clear selection first so claim form reset does not refetch a deleted id
    onClose && onClose()
    $(`#${modalId}`).modal('hide')
    dispatch(claimFormReset())
    dispatch(visionInsuranceClaimFormReset())
    dispatch(orderLoad(order.id, { include: '*' }))
  }

  const handleInsuranceSwitch = (orderInsurance) => {
    setActiveOrderInsurance(orderInsurance)
  }

  const selectedInsuranceName = activeOrderInsurance?.patient_insurance_attributes?.insurance_name || 'Claim Form'

  return createPortal(
    <ModalFormWrapper
      formName={formName}
      hideHeader
      modalSize="claim-form-modal__dialog"
      modalContentClasses="border-0 bg-transparent post-check-modal--form claim-form-modal--drawer"
      handleEditCancel={handleClose}
    >
      <div className="post-check-modal__dialog post-check-modal__dialog--wide claim-form-modal__content mx-auto">
        <div className="post-check-modal__card claim-form-modal__card">
          <div className="claim-form-modal__title-header border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="dropdown">
                <button
                  className="btn btn-link dropdown-toggle claim-form-modal__title p-0"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Claim Form : {selectedInsuranceName}
                </button>
                {claimFormInsurances.length > 1 && (
                  <div className="dropdown-menu border-0 shadow rounded my-3 py-0">
                    {claimFormInsurances.map((orderInsurance) => (
                      <button
                        key={orderInsurance.id}
                        type="button"
                        className={`dropdown-item py-3 ${activeOrderInsurance?.id === orderInsurance.id ? 'active' : ''}`}
                        onClick={() => handleInsuranceSwitch(orderInsurance)}
                      >
                        {getInsuranceLabel(orderInsurance)}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <button type="button" className="btn btn-outline-primary text-nowrap" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>

          {showClaimForm && (isForm1500 || activeOrderInsurance?.claim_form_id) && (
            <div className="claim-form-modal__actions bg-light">
              <ClaimFormHeader
                dispatch={dispatch}
                order={order}
                trizettoSending={trizettoSending}
                ediClearingHouseConfig={ediClearingHouseConfig}
                onTrizettoSend={onTrizettoSend}
                userRole={userRole}
                selectedOrderInsurance={activeOrderInsurance}
                claimFormId={activeOrderInsurance?.claim_form_id}
                inModal
                onDelete={handleClose}
              />
            </div>
          )}

          <div className="claim-form-modal__body">
            {showClaimForm && (isForm1500 || activeOrderInsurance?.claim_form_id ? (
              <ClaimForm
                order={order}
                onSubmit={onSubmit}
                onSecureFax={onSecureFax}
                onTrizettoSend={onTrizettoSend}
                selectedOrderInsurance={activeOrderInsurance}
                inModal
              />
            ) : (
              <RpaClaimForm />
            ))}
          </div>
        </div>
      </div>
    </ModalFormWrapper>,
    document.body
  )
}

const mapStateToProps = (state) => {
  const {
    order: { order },
    claimForm: { trizettoSending },
    organisation: { organisation },
    auth,
  } = state

  return {
    order,
    trizettoSending,
    ediClearingHouseConfig: organisation.add_ons_config?.type?.edi_clearing_house,
    userRole: auth.user?.role,
  }
}

export default connect(mapStateToProps)(ClaimFormModal)
